import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./auth-context";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import {DarkModeProvider} from "./core/DarkModeContext";

const stripePromise = loadStripe('pk_test_qgYjwvFA9dKFKUGfAR8mzhQ5');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <Elements stripe={stripePromise}>
            <DarkModeProvider>
                <App/>
            </DarkModeProvider>
        </Elements>
    </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
